import styled from 'styled-components';
import variables from '@styles/variables';
import CmsContentSlot from '@atoms/CmsContentSlot/CmsContentSlot';

export const StyledPosition3Slot = styled(CmsContentSlot)`
  display: flex;
  flex-direction: column;
  background: ${variables.colors.lighterGray};
`;
